import { render, staticRenderFns } from "./UploadQuestionnaire.vue?vue&type=template&id=535b0e7e&scoped=true&"
import script from "./UploadQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./UploadQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./UploadQuestionnaire.vue?vue&type=style&index=0&id=535b0e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b0e7e",
  null
  
)

export default component.exports